import { createContext, useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";

export const SITE_URL = "https://peplaroofing.com";

// During pre-rendering, pages write their head tags into this context so the
// static HTML ships with the right title, description and structured data.
export const HeadContext = createContext(null);

const pageUrl = (pathname) => SITE_URL + (pathname === "/" ? "/" : pathname.replace(/\/$/, ""));

const setTag = (selector, create, attr, value) => {
  let tag = document.head.querySelector(selector);
  if (!tag) {
    tag = create();
    document.head.appendChild(tag);
  }
  tag.setAttribute(attr, value);
};
const meta = (key, keyAttr) => () => {
  const m = document.createElement("meta");
  m.setAttribute(keyAttr, key);
  return m;
};

const SEO = ({ title, description, jsonLd, lang, alternate }) => {
  const { pathname } = useLocation();
  const ssr = useContext(HeadContext);
  const url = pageUrl(pathname);

  if (ssr) {
    Object.assign(ssr, { title, description, url, jsonLd: jsonLd || null, lang: lang || "en", alternate: alternate || null });
  }

  useEffect(() => {
    document.documentElement.lang = lang || "en";
    if (title) {
      document.title = title;
      setTag('meta[property="og:title"]', meta("og:title", "property"), "content", title);
    }
    if (description) {
      setTag('meta[name="description"]', meta("description", "name"), "content", description);
      setTag('meta[property="og:description"]', meta("og:description", "property"), "content", description);
    }
    setTag('link[rel="canonical"]', () => Object.assign(document.createElement("link"), { rel: "canonical" }), "href", url);
    setTag('meta[property="og:url"]', meta("og:url", "property"), "content", url);

    let script = document.getElementById("page-jsonld");
    if (jsonLd) {
      if (!script) {
        script = Object.assign(document.createElement("script"), { id: "page-jsonld", type: "application/ld+json" });
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(jsonLd);
    } else if (script) {
      script.remove();
    }
    window.scrollTo(0, 0);
  }, [title, description, url, jsonLd]);

  return null;
};

export default SEO;
